// CONSTANTS are all caps.
const NS = 'MailingListCdc';
const CLS = 'mailingListCdc';
const BLK = '.' + CLS + '-';
const TYPE_MESSAGE = {
	CustomerInCDCAndOptInExistInEmarsysMessage: 'CustomerInCDCAndOptInExistInEmarsysMessage',
	CustomerInCDCAndOptInNotExistInEmarsysMessage: 'CustomerInCDCAndOptInNotExistInEmarsysMessage',
	CustomerNotInCDCAndOptInNotExistInEmarsysMessage: 'CustomerNotInCDCAndOptInNotExistInEmarsysMessage',
};
import CDC, {CdcService} from '../../../../global/js/cdc';
import {CDC_ACCOUNT_DATA, STAFF_CARD_NO, STAFF_CARD_NO_OPT} from '../../../../global/js/constants';
import * as utils from '../../../../global/js/utils';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class MailingListCdc extends CDC {
	constructor(el) {
		super(el);
		this.cdcService = new CdcService();
		this.typeMessage = TYPE_MESSAGE.CustomerNotInCDCAndOptInNotExistInEmarsysMessage;
		this.validate = {
			'profile.email': ['required', 'email'],
        };
	}

	init() {
	}

	_onAfterScreenLoad() {
		this.$blockQuery.find('input[name="profile.firstName"], input[name="profile.lastName"], input[name="profile.email"]').val('');
		this._showForm();
	}

	_onSubmit(event) {
		utils.showLoading();
		return this.checkTypeMessage(event).finally(() => {
			utils.hideLoading();
		});
	}

	onAfterSubmit(response) {
		let status = response.status;
		let UID = response.UID;
		window.dataLayer = window.dataLayer || [];
		if (status === 'OK') {
			this.renderMessage(this.typeMessage);
			window.dataLayer.push({
                'event': 'signUp',
                'eventCategory': 'Sign Up',
                'eventAction': 'Email Updates',
                'userId': UID,
            });
		}
	}

	updateFormData(event, data = {}) {
		const customerTypeCode = 'customerTypeCode';
		event.formModel.data[customerTypeCode] = data.CustomerTypeCode || event.formModel.data[customerTypeCode] || CDC_ACCOUNT_DATA.CUSTOMER_TYPE_CODE;
		data[STAFF_CARD_NO_OPT] && (event.formModel.data[STAFF_CARD_NO] = data[STAFF_CARD_NO_OPT]);
		this.cdcService.setAcquisitionChannel(event, data, CDC_ACCOUNT_DATA.ACQUISITION_CHANNEL_FOOTER, true);
	}

	checkTypeMessage(event) {
		return new Promise((resolve, reject) => {
			const email = event.formModel.profile.email;
			const setAccountInfo = () => {
				this.cdcService.setAccountInfoWithToken(event.formModel)
					.then((res) => {
						this.onAfterSubmit(res);
					})
					.finally(() => {
						reject();
					});
			};

			this.cdcService.searchAccountByEmail(email).then((data) => {
				if (data) {
					if (data.OptIn) {
						this.typeMessage = TYPE_MESSAGE.CustomerInCDCAndOptInExistInEmarsysMessage;
					} else {
						this.typeMessage = TYPE_MESSAGE.CustomerInCDCAndOptInNotExistInEmarsysMessage;
					}
				} else {
					this.typeMessage = TYPE_MESSAGE.CustomerNotInCDCAndOptInNotExistInEmarsysMessage;
				}
				this.updateFormData(event, data || {});
				setAccountInfo();
			}).catch(() => {
				setAccountInfo();
			});
		});
	}

	renderMessage(typeMessage) {
		this.$blockQuery.css('display', 'none');
		this.$blockQuery.closest('.mailinglistblock').find(`.message-mailing[data-key="${typeMessage}"]`).css('display', 'block');
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/blocks/mailingListCdc/js/mailingListCdc.js